export type FooterLinkAction = 'guarantee' | 'buyTour';

export interface FooterLink {
  text: string;
  href: string;
  newTab?: boolean;
  action?: FooterLinkAction;
}

export const FOOTER_USEFUL_LINKS: FooterLink[] = [
  { text: 'Гарантия честных цен', href: '', action: 'guarantee' },
  { text: 'Пресса о нас', href: '/press.html' },
  { text: 'Отзывы наших клиентов', href: '/testimonials' },
  { text: 'Купить тур из Москвы', href: '', action: 'buyTour' },
  { text: 'Узнайте больше о странах', href: '/atlas' },
  { text: 'Рейтинг туроператоров', href: '/rating' },
];

export const FOOTER_LEGAL_LINKS: FooterLink[] = [
  {
    text: 'Политика о персональных данных',
    href: 'https://static.travelatacdn.ru/showcase/documents/privacy/cb58e75e-d2e6-4543-ab7e-1ff29ea71765.pdf',
    newTab: true,
  },
  {
    text: 'Политика использования файлов cookie',
    href: 'https://static.travelatacdn.ru/showcase/documents/cookies_agreement/79bf276c-d68e-4a0d-9b1c-e217e738d816.pdf',
    newTab: true,
  },
  {
    text: 'Пользовательское соглашение',
    href: 'https://static.travelatacdn.ru/showcase/documents/user_agreement/8f39b223-a195-4d66-9963-1b5a22f5a25f.pdf',
    newTab: true,
  },
  {
    text: 'Согласие на обработку персональных данных',
    href: 'https://static.travelatacdn.ru/showcase/documents/personal_data_agreement/15fd0313-3213-41f9-a8a5-eecaac456129.pdf',
    newTab: true,
  },
  {
    text: 'На сайте применяются рекомендательные технологии',
    href: 'https://static.travelatacdn.ru/showcase/documents/recommendation_technologies_agreement/87cbe1ac-5113-4075-8b83-d83b9c4818a4.pdf',
    newTab: true,
  },
  { text: 'Блог', href: 'https://travelata.ru/blog/', newTab: true },
  { text: 'Карта сайта', href: 'https://travelata.ru/linkmap', newTab: true },
];
